// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ClosuresChargeList    = lazy(() => import('../../views/closures/charge/list'))
const ClosuresChargeEdit    = lazy(() => import('../../views/closures/charge/edit'))
const ClosuresChargePrint   = lazy(() => import('../../views/closures/charge/print'))
const ClosuresChargePreview = lazy(() => import('../../views/closures/charge/preview'))

const ClosuresCharge = [
  {
    path: '/closures/charge/list',
    element: <ClosuresChargeList />
  },
  {
    path: '/closures/charge/edit/:id',
    element: <ClosuresChargeEdit/>
  },
  {
    path: '/closures/charge/print/:id',
    element: <ClosuresChargePrint />
  },
  {
    path: '/closures/charge/preview/:id',
    element: <ClosuresChargePreview />
  }
]

export default ClosuresCharge
